module.exports = __webpack_public_path__ + "static/media/banner_2.1cf3c7d8.png";